import * as React from 'react';
import {
  Pagination,
} from 'react-admin';

// eslint-disable-next-line max-len
export default React.memo((props: any) => <Pagination rowsPerPageOptions={[100, 150, 200, 250, 300]} {...props} />);
